export const environment = {
  isMaintenance: false,
  appname: 'UP Station',
  AD_SLOT: '8900054158',
  AD_CLIENT: 'ca-pub-6353801223423138',
  gAnalyticKey: 'G-ZHD4S8TY3H',
  restUrl: 'https://ms-auth.api.upstation.media/api/v1/', 
  gqlUrl: 'https://ms-gateway.api.upstation.media/graphql',
  webDomain: 'https://www.upstation.media',
  firebaseConfig: {
    apiKey: 'AIzaSyCTf9dRJ-ZOuhb7XAmOnwxArCnkmqKElk0',
    authDomain: 'upstation-nextgen-dev.firebaseapp.com',
    projectId: 'upstation-nextgen-dev',
    storageBucket: 'upstation-nextgen-dev.appspot.com',
    messagingSenderId: '1073097854758',
    appId: '1:1073097854758:web:813485073bdcb7c291fbe7',
    measurementId: 'G-QHMNK13K7H'
  }
};
